// The browser Supabase client for the tournament web app.
//
// The publishable key is MEANT to be in this bundle — Row Level Security is what protects
// the data, not the secrecy of this key. The database password is a different thing and
// never belongs anywhere near here.

import { createClient } from '@supabase/supabase-js';

const URL = import.meta.env.VITE_SUPABASE_URL ?? '';
const KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '';

export const CONFIGURED = URL.length > 0 && KEY.length > 0;

export const supabase = createClient(URL, KEY, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

/** Anything the server threw, in words worth showing somebody. */
export function errText(err: unknown): string {
  if (!err) return 'Something went wrong';
  if (typeof err === 'string') return err;
  const e = err as { message?: string; details?: string; hint?: string };
  return e.message || e.details || e.hint || 'Something went wrong';
}
